import React, { useMemo, useState } from 'react';
import { Button } from '@material-ui/core';
import DeviceStatusBadge from '../DeviceStatusBadge';
import HardwareStatusesDialog from './HardwareStatusesDialog';
import useStyles from './styles';
import {
  HardwareDeviceStatus,
  HardwareStatusSummary,
} from '../../types/HardwareStatus';
import {
  getCollapsedHardwareStatuses,
  getDeviceStatusIcon,
  getHardwareStatusIcon,
  getLockStatusIcon,
} from '../../utils/hardwareStatus';

type Props = {
  hardwareStatuses?: HardwareDeviceStatus[];
  deviceStatus?: HardwareStatusSummary;
  lockStatus?: HardwareStatusSummary;
};

const HardwareStatusBadges: React.FC<Props> = ({
  hardwareStatuses = [],
  deviceStatus,
  lockStatus,
}: Props) => {
  const classes = useStyles();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const collapsedStatuses = useMemo(
    () => getCollapsedHardwareStatuses(hardwareStatuses),
    [hardwareStatuses],
  );

  if (hardwareStatuses.length) {
    return (
      <>
        <div className={classes.statusList}>
          {collapsedStatuses.primary.map(hardware => (
            <DeviceStatusBadge
              key={`${hardware.deviceId}-${hardware.deviceType}`}
              label={`${hardware.deviceName}: ${hardware.label}`}
              variant={hardware.variant}
              icon={getHardwareStatusIcon(hardware)}
            />
          ))}
          {collapsedStatuses.remaining.length > 0 && (
            <Button
              aria-haspopup="dialog"
              className={classes.showMoreButton}
              onClick={() => setIsModalOpen(true)}
              size="small"
            >
              {`Show more (${collapsedStatuses.remaining.length})`}
            </Button>
          )}
        </div>
        {collapsedStatuses.remaining.length > 0 && (
          <HardwareStatusesDialog
            hardwareStatuses={hardwareStatuses}
            onClose={() => setIsModalOpen(false)}
            open={isModalOpen}
          />
        )}
      </>
    );
  }

  return (
    <div className={classes.statusList}>
      {deviceStatus && (
        <DeviceStatusBadge
          label={`Panel: ${deviceStatus.label}`}
          variant={deviceStatus.variant}
          icon={getDeviceStatusIcon(deviceStatus)}
        />
      )}
      {lockStatus && lockStatus.status !== 'not_available' && (
        <DeviceStatusBadge
          label={`Door Lock: ${lockStatus.label}`}
          variant={lockStatus.variant}
          icon={getLockStatusIcon(lockStatus)}
        />
      )}
    </div>
  );
};

export default React.memo(HardwareStatusBadges);
